import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import IndexApp from "../../Components/IndexApp";
import { getActiveBrandConfig } from "../../config/environment.config";
import { isTeachrAccountActive } from "../../Utils/Function";
import { DV2 } from "../../App/DeclarationV2/theme";
import { Notice, TextLink } from "../../App/DeclarationV2/layout/Ui";
import { vocab } from "../../App/DeclarationV2/vocabulary";
import CourseEdit from "../../App/CourseEditV2/CourseEditForm";
import useEditableCourse from "../../App/CourseEditV2/useEditableCourse";
import { coursesPath } from "../../App/CourseEditV2/paths";

/**
 * Modifier un cours à venir ou du mois, route
 * `/{marque}/tableau-de-bord/{prestation}/modifier/:courseId` : la page de
 * modification des brouillons v2 appliquée aux cours existants. La modale
 * « Modification du cours » reste en place pour les brouillons.
 */
const CourseEditV2Page = () => {
    const navigate = useNavigate();
    const { courseId } = useParams<{ courseId: string }>();
    const teachr = useSelector((s: any) => s.user.currentUser.teachr);
    const id = courseId ? parseInt(courseId, 10) : null;
    const { course, loading } = useEditableCourse(teachr, Number.isFinite(id as number) ? id : null);

    useEffect(() => {
        if (teachr?.id && !isTeachrAccountActive(teachr)) {
            navigate(`/${getActiveBrandConfig()}/profile/complete`, { replace: true });
        }
    }, [teachr, navigate]);

    const body = () => {
        if (course) return <CourseEdit key={course.id} course={course} teachr={teachr} />;
        if (loading) {
            return (
                <div style={{ padding: 48, textAlign: "center", color: DV2.muted, fontSize: 14 }}>
                    <CircularProgress size={18} style={{ marginRight: 8, verticalAlign: "middle" }} /> Chargement {vocab.ofTheCourse()}…
                </div>
            );
        }
        return (
            <div className="mx-auto w-full max-w-3xl px-4 sm:px-6 py-8">
                <Notice tone="info" action={<TextLink label={`Voir mes ${vocab.courses()}`} onClick={() => navigate(coursesPath())} />}>
                    {`${vocab.thisCourse().charAt(0).toUpperCase()}${vocab.thisCourse().slice(1)} est introuvable : il a peut-être été supprimé, ou n'est plus dans vos ${vocab.courses()} à venir.`}
                </Notice>
            </div>
        );
    };

    return (
        <IndexApp
            navBar={{ index: 1 }}
            teachr={teachr}
            component={
                <main style={{ background: DV2.pageBg, minHeight: "calc(100vh - 64px)" }}>
                    {teachr?.id ? body() : null}
                </main>
            }
        />
    );
};

export default CourseEditV2Page;
